"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Separator = Separator;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
function Separator(props) {
    const { children, ...otherProps } = props;
    return (0, jsx_runtime_1.jsx)(antd_1.Divider, { ...otherProps, children: children });
}
